/** API route map: URLS.Controller.EmployeeSkill */
export const EmployeeSkill = {
      Name: 'EmployeeSkills/',
      GetSkills: 'get-employee-skills',
      SearchSkills: 'search-skills',
      AddSkill: 'add-skill',
      UpdateSkill: 'update-skill',
      UpsertSkill: 'upsert-skills',
      NewSkills: 'new-skills',
      AddNewSkills: 'add-new-skills',
      GetEmployeeSkills: 'all-employee-skills',
      DeleteSkill: 'delete',
};
